"use strict";

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _regeneratorRuntime = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var BlockModule = /*#__PURE__*/function () {
  function BlockModule(sdk) {
    _classCallCheck(this, BlockModule);

    this.sdk = sdk;
    this.state$ = new BlockModule.State(); //
  }

  _createClass(BlockModule, [{
    key: "initialize",
    value: function initialize() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var _this$sdk$clients, platform, relayer, gasPrice;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$sdk$clients = this.sdk.clients, platform = _this$sdk$clients.platform, relayer = _this$sdk$clients.relayer;

                if (platform) {
                  platform.subscribeBlockMinded().subscribe(function (hash) {
                    return _this.state$.update({
                      hash: hash
                    });
                  });
                }

                if (!relayer) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return relayer.getGasPrice();

              case 5:
                gasPrice = _context.sent;
                this.state$.update({
                  gasPrice: gasPrice
                });
                relayer.subscribeGasPrice().subscribe(function (gasPrice) {
                  return _this.state$.update({
                    gasPrice: gasPrice
                  });
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "state",
    get: function get() {
      return this.state$.getValue();
    }
  }, {
    key: "gasPrice",
    get: function get() {
      return this.state.gasPrice;
    }
  }]);

  return BlockModule;
}();

exports.BlockModule = BlockModule;

(function (BlockModule) {
  var State = /*#__PURE__*/function (_utils_1$StateSubject) {
    _inherits(State, _utils_1$StateSubject);

    var _super = _createSuper(State);

    function State() {
      var _this2;

      _classCallCheck(this, State);

      _this2 = _super.call(this, {
        gasPrice: null,
        hash: null
      });
      _this2.gasPrice$ = _this2.getSubSubject('gasPrice');
      _this2.hash$ = _this2.getSubSubject('hash');
      return _this2;
    }

    return State;
  }(utils_1.StateSubject);

  BlockModule.State = State;
})(BlockModule = exports.BlockModule || (exports.BlockModule = {}));